import React from "react";
import { Field, useFormikContext } from "formik";

const IntroducirCodigo = ({
  mensajeycodigo,
  handleAtras,
}) => {

  const {dirty, resetForm} = useFormikContext();
  
  return (
    <>
      <div>
        <div className="text-center w-full">
          <p className=" text-white text-base w-full">
            {mensajeycodigo.Mensaje.Mensaje}
          </p>

          <p className=" text-white text-base w-full">
            Por favor ingresa el código en el siguiente cuadro de texto
          </p>

          <div className="py-1 flex w-full">
            <Field
              name="codigo"
              type="text"
              className={
                "text-center flex flex-col w-full items-center mb-2 rounded-md border-gray-300  focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
              }
            ></Field>
          </div>
          <p className="text-white text-base w-full">Si no son sus datos registrados debe comunicarse a su sede para actualizarlos</p>
          <div className="flex flex-row gap-2">
            <button
              className="w-full mt-4 px-6 py-2 font-bold bg-azulBrillanteMira hover:bg-secundario transition duration-500 ease text-white rounded-lg"
              type="button"
              name="passStep2"
              onClick={(e) => {handleAtras(e.target);resetForm()}}
            >
              Atrás
            </button>
            <button
              className="w-full mt-4 px-6 py-2 font-bold bg-azulBrillanteMira hover:bg-secundario transition duration-500 ease text-white rounded-lg"
              type="submit"
            >
              Siguiente
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default IntroducirCodigo;
